//import { Auth } from "./pages/auth";
import { Register } from "./pages/register";
import {BrowserRouter as Router,  Route, Routes} from 'react-router-dom'
//import { Navbar } from "./components/navbar"; 
//import { Profile} from "./pages/profile";
import { Footer } from "./components/footer";
//import { ResetPassword } from "./components/resetPassword";
//import { DiscoveryPage } from "./pages/discoveryPage";
import { About } from "./pages/about";
import { Pricing } from "./pages/pricing";
import { Terms } from "./pages/terms-of-service";
import { PrivacyPolicy } from "./pages/privacy-policy";
import { Voluntary } from "./pages/voluntary";
import { Confirmation } from "./pages/confirmation";


function App() {
  return (
    <div className="App">
      <Router>
        {/*<Navbar/> */}
        <Routes>
          <Route path='/' element={<About/>} />
          <Route path='/register' element={<Register/>} />
          {/* <Route path='/profile/:uid' element={<Profile/>} /> */}
          {/*<Route path='/resetPassword' element={<ResetPassword/>} />*/}
         {/* <Route path='/discovery' element={<DiscoveryPage/>} />*/}
         {/* <Route path='/login' element={<Auth/>} />*/}
          <Route path='/pricing' element={<Pricing/>} />
          <Route path='/terms-of-service' element={<Terms/>} />
          <Route path='/confirmation' element={<Confirmation/>}/>
          <Route path='/privacy-policy' element={<PrivacyPolicy/>} />
          <Route path='/voluntary' element={<Voluntary/>} />
        </Routes>
      </Router>
      <Footer/>
    </div>
  );
}

export default App;
  